import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M16 20H8a3 3 0 0 1-3-3V7a1 1 0 0 0-2 0v10a4.9997 4.9997 0 0 0 5 5h8a1.0001 1.0001 0 0 0 0-2m5-11.06a1.3 1.3 0 0 0-.06-.27v-.09a1.07 1.07 0 0 0-.19-.28l-6-6a1.07 1.07 0 0 0-.28-.19h-.09L14.06 2H10a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3zm-6-3.53L17.59 8H16a1 1 0 0 1-1-1zM19 15a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a3 3 0 0 0 3 3h3z"
}), "Copy", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
